import { render, staticRenderFns } from "./formCreateBank.vue?vue&type=template&id=40adcbd2"
import script from "./formCreateBank.vue?vue&type=script&lang=js"
export * from "./formCreateBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40adcbd2')) {
      api.createRecord('40adcbd2', component.options)
    } else {
      api.reload('40adcbd2', component.options)
    }
    module.hot.accept("./formCreateBank.vue?vue&type=template&id=40adcbd2", function () {
      api.rerender('40adcbd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/bank/components/form/formCreateBank.vue"
export default component.exports